VIV.behaviours.text = (function () {

    const attach = function (context) {
        context.querySelectorAll('.text').forEach(element => {
            init(element);
        });
    };

    const init = function (element) {

    };

    return {
        attach: attach
    }
})();
